import { useContext } from 'react';
import { Grid, TablePagination, Typography } from '@material-ui/core';
import { ChangeUser } from 'components';
import { registrationsContext } from '../RegistrationsContext';
import { appUserContext } from 'helpers/services';
import { UserType } from 'helpers/enums';


let Toolbar = () => {
    let { currentUser } = useContext(appUserContext);
    let service = useContext(registrationsContext);


    return (
        <Grid container alignItems="center">
            {currentUser?.userType !== UserType.Videndum && <Grid item xs />}
            {currentUser?.userType === UserType.Videndum &&
                <>
                    {service.selectedItems.length > 0 &&
                        <Grid item xs>
                            <Typography>{service.selectedItems.length} registrations selected</Typography>
                        </Grid>
                    }

                    <Grid item xs />

                    {service.selectedItems.length > 0 &&
                        <Grid item>
                            <ChangeUser
                                selectedItems={service.selectedItems}
                                onClose={service.doSearch}
                            />
                        </Grid>
                    }
                </>
            }

            <Grid item>
                <TablePagination
                    component="div"
                    count={service.recordCount}
                    onPageChange={(e, page) => service.changePage(page)}
                    page={service.search.pageNr}
                    rowsPerPage={service.search.pageSize}
                    rowsPerPageOptions={[service.search.pageSize]}
                    labelDisplayedRows={({ page }) =>
                        <>
                            Total registrations:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                            <span>Page {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                        </>
                    }
                />
            </Grid>
        </Grid>
    )
}

export default Toolbar;